var _defs, _g, _g2, _g3, _mask, _g4, _line, _line2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarMonthEmptyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "118px",
    height: "129px",
    viewBox: "0 0 118 129",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.650622815,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,40.0909091 L118,40.0909091 L118,116.125777 C118,120.549902 114.413538,124.136364 109.989413,124.136364 L8.01058713,124.136364 C3.58646202,124.136364 4.09451274e-15,120.549902 0,116.125777 L0,40.0909091 L0,40.0909091 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.5%",
    y: "-3.6%",
    width: "105.1%",
    height: "107.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -3,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.06 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.9833333,1.14772727 L26.9833333,25.5795455",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-407.6%",
    y: "-25.6%",
    width: "915.2%",
    height: "167.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.49919991,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.49919991,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowInner",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "shadowInner",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.850980392   0 0 0 0 0.850980392   0 0 0 0 0.850980392  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94.4,1.48863636 L94.4,25.9204545",
    id: "path-6"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-407.6%",
    y: "-25.6%",
    width: "915.2%",
    height: "167.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.49919991,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.49919991,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowInner",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "shadowInner",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.850980392   0 0 0 0 0.850980392   0 0 0 0 0.850980392  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "46.9986979%",
    y1: "100%",
    x2: "46.9986979%",
    y2: "0%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109.989413,11.75 C114.413538,11.75 118,15.336462 118,19.7605871 L118,40.0909091 L0,40.0909091 L0,19.7605871 C0,15.336462 3.58646202,11.75 8.01058713,11.75 L109.989413,11.75 Z M26.55,18.5909091 C22.74844,18.5909091 19.6666667,21.6536884 19.6666667,25.4318182 C19.6666667,29.2099479 22.74844,32.2727273 26.55,32.2727273 C30.35156,32.2727273 33.4333333,29.2099479 33.4333333,25.4318182 C33.4333333,21.6536884 30.35156,18.5909091 26.55,18.5909091 Z M94.4,18.5909091 C90.59844,18.5909091 87.5166667,21.6536884 87.5166667,25.4318182 C87.5166667,29.2099479 90.59844,32.2727273 94.4,32.2727273 C98.20156,32.2727273 101.283333,29.2099479 101.283333,25.4318182 C101.283333,21.6536884 98.20156,18.5909091 94.4,18.5909091 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.3%",
    y: "-5.3%",
    width: "102.5%",
    height: "110.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-11"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.7 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "18.8476562%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDBDBD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9E9E9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.0373733%",
    y1: "93.0373733%",
    x2: "43.0373733%",
    y2: "6.96262669%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "HH---Mental-Wellbeing-Assessment-Results",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HH----Mental-Wellbeing-Assessment-Results-3-Copy-4",
    transform: "translate(-302.000000, -2307.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(302.000000, 2310.853280)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Line-4",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-5)",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#979797",
    strokeWidth: 6.99839981,
    xlinkHref: "#path-4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Line-4-Copy",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-7)",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#979797",
    strokeWidth: 6.99839981,
    xlinkHref: "#path-6"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-8)",
    fillRule: "evenodd",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-11)",
    xlinkHref: "#path-9"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 27,
    y1: 0.488636364,
    x2: 27,
    y2: 24.9204545,
    id: "Line-4",
    stroke: "url(#linearGradient-12)",
    strokeWidth: 7.9984,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 94,
    y1: 0.488636364,
    x2: 94,
    y2: 24.9204545,
    id: "Line-4-Copy-2",
    stroke: "url(#linearGradient-12)",
    strokeWidth: 7.9984,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,40.0909091 L118,40.0909091 L118,41.0140915 C118,41.4271751 117.66513,41.7620455 117.252046,41.7620455 L0.74795398,41.7620455 C0.334870403,41.7620455 4.49148025e-15,41.4271751 0,41.0140915 L0,40.0909091 L0,40.0909091 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-13)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    opacity: 0.5,
    x: 0,
    y: 40.2553409,
    width: 118,
    height: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 7.80165289,
    y: 32.75,
    width: 15.6033058,
    height: 15.6363636,
    rx: 1.74959995
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#D9D9D9",
    strokeWidth: 0.874799977,
    fill: "#FFFFFF",
    x: 8.23905288,
    y: 51.4374,
    width: 14.7285058,
    height: 14.7615637,
    rx: 1.74959995
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#D9D9D9",
    strokeWidth: 0.874799977,
    fill: "#FFFFFF",
    x: 8.23905288,
    y: 73.4374,
    width: 14.7285058,
    height: 14.7615637,
    rx: 1.74959995
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#D9D9D9",
    strokeWidth: 0.874799977,
    fill: "#FFFFFF",
    x: 29.6935983,
    y: 51.2783091,
    width: 14.7285058,
    height: 14.7615637,
    rx: 1.74959995
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#D9D9D9",
    strokeWidth: 0.874799977,
    fill: "#FFFFFF",
    x: 29.6935983,
    y: 73.7555818,
    width: 14.7285058,
    height: 14.7615637,
    rx: 1.74959995
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#D9D9D9",
    strokeWidth: 0.874799977,
    fill: "#FFFFFF",
    x: 29.6935983,
    y: 96.2328545,
    width: 14.7285058,
    height: 14.7615637,
    rx: 1.74959995
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#D9D9D9",
    strokeWidth: 0.874799977,
    fill: "#FFFFFF",
    x: 52.1233504,
    y: 51.2783091,
    width: 14.7285058,
    height: 14.7615637,
    rx: 1.74959995
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#D9D9D9",
    strokeWidth: 0.874799977,
    fill: "#FFFFFF",
    x: 52.1233504,
    y: 73.7555818,
    width: 14.7285058,
    height: 14.7615637,
    rx: 1.74959995
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#D9D9D9",
    strokeWidth: 0.874799977,
    fill: "#FFFFFF",
    x: 52.1233504,
    y: 96.2328545,
    width: 14.7285058,
    height: 14.7615637,
    rx: 1.74959995
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#D9D9D9",
    strokeWidth: 0.874799977,
    fill: "#FFFFFF",
    x: 73.5778959,
    y: 51.2783091,
    width: 14.7285058,
    height: 14.7615637,
    rx: 1.74959995
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#D9D9D9",
    strokeWidth: 0.874799977,
    fill: "#FFFFFF",
    x: 73.5778959,
    y: 73.7555818,
    width: 14.7285058,
    height: 14.7615637,
    rx: 1.74959995
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#D9D9D9",
    strokeWidth: 0.874799977,
    fill: "#FFFFFF",
    x: 73.5778959,
    y: 96.4374,
    width: 14.7285058,
    height: 14.7615637,
    rx: 1.74959995
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#D9D9D9",
    strokeWidth: 0.874799977,
    fill: "#FFFFFF",
    x: 95.0324413,
    y: 51.2783091,
    width: 14.7285058,
    height: 14.7615637,
    rx: 1.74959995
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#D9D9D9",
    strokeWidth: 0.874799977,
    fill: "#FFFFFF",
    x: 95.0324413,
    y: 73.7555818,
    width: 14.7285058,
    height: 14.7615637,
    rx: 1.74959995
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 94.5950413,
    y: 95.7954545,
    width: 15.6033058,
    height: 15.6363636,
    rx: 1.74959995
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarMonthEmptyIcon);
export default __webpack_public_path__ + "static/media/calendar-month-empty-icon.a52effc76c035dddb6b77685f201ade5.svg";
export { ForwardRef as ReactComponent };